import { Colors } from '@ab-core/colors';
import { FontTypes } from '@ab-core/font-types';
import { RADIUS } from '@ab-core/radius';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const StyledTag = styled.div`
    border-radius: ${RADIUS.FULL};
    padding: ${SPACING.SMALL} ${SPACING.SMALL_2};
    border-width: 1px;
    border-style: solid;
    text-indent: 2px;
    font-weight: ${FontTypes.button.fontWeight};
    font-size: ${FontTypes.button.fontSize};
    line-height: ${FontTypes.button.lineHeight};
    letter-spacing: ${FontTypes.button.letterSpacing};
    text-transform: ${FontTypes.button.textTransform};

    &.ab-tag-primary {
        background-color: ${Colors.primary};
        border-color: ${Colors.primary};
        color: ${Colors.white};
    }

    &.ab-tag-secondary {
        border-color: ${Colors.primary};
        color: ${Colors.primary};
    }

    &.ab-tag-tertiary {
        border-color: ${Colors.gray70};
        color: ${Colors.gray70};
    }
    &.ab-tag-success {
        background-color: ${Colors.success};
        border-color: ${Colors.success};
        color: ${Colors.white};
    }
    &.ab-tag-info {
        background-color: ${Colors.info};
        border-color: ${Colors.info};
        color: ${Colors.white} !important;
    }
    &.ab-tag-warning {
        background-color: ${Colors.warning};
        border-color: ${Colors.warning};
        color: ${Colors.black};
    }
    &.ab-tag-error {
        background-color: ${Colors.error};
        border-color: ${Colors.error};
        color: ${Colors.white};
    }
    &.ab-tag-gold {
        background-color: ${Colors.gold};
        border-color: ${Colors.gold};
        color: ${Colors.white};
    }
`;

export const StyledTags = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-content: center;
    gap: ${SPACING.SMALL_3};
`;
